import React from 'react';

// New
import { withSidebarNavigation, withSocialMediaLinks } from '@hooks';
import { ButtonClose } from '@components/navigations/SidebarNavigation/ButtonClose';
import { List } from '@components/navigations/SidebarNavigation/List';
import { SmallList } from '@components/navigations/SidebarNavigation/SmallList';
import { SocialList } from '@components/navigations/SidebarNavigation/SocialList';

// Styles
import styles from './OverlaySidebar.module.scss';

// Constants
import { REGION_OVERLAYS } from '@shcc/constants';

// Components
import i18n from '@components/i18n/i18n';

const OVERLAY_FRAGMENT = 'sidebar';

class OverlaySidebar extends React.Component {
  hideMe = this.hideMe.bind(this);
  transitionEnd = this.transitionEnd.bind(this);
  state = {
    subMenuData: null,
    subMenuIsOpen: false,
    direction: 'ltr',
    show: false,
  };

  componentWillUnmount() {
    document.body.classList.remove('lock');
  }

  componentDidMount() {
    document.body.classList.add('lock');
    const direction = i18n.dir();
    this.setState({
      direction: direction,
    });

    // state.show needs to be set asyncronously for the entering animation to work
    setTimeout(() => {
      this.setState({
        show: true,
      });
    });
  }

  hideMe() {
    document.body.classList.remove('lock');
    this.setState({
      show: false,
    });
  }

  transitionEnd() {
    if (!this.state.show) {
      this.props.closeSidebarHandler();
    }
  }

  render() {
    const navLeftOrRight = this.state.direction === 'ltr' ? 'right' : 'left';

    return (
      <React.Fragment>
        <nav
          className={[
            styles.content,
            navLeftOrRight === 'right'
              ? styles.sidebarRight
              : styles.sidebarLeft,
            this.state.show && styles.show,
          ].join(' ')}
          onTransitionEnd={this.transitionEnd}
        >
          {this.props.lists.map(item => {
            if (!item.children) return null;
            return item.type === 'small' ? (
              <SmallList
                items={item.children}
                onClick={this.hideMe}
                key={item.drupal_id}
              />
            ) : (
              <List
                items={item.children}
                onClick={this.hideMe}
                key={item.drupal_id}
              />
            );
          })}

          <SocialList
            items={this.props.social?.relationships?.field_social_link || []}
            className={styles.social}
          />


          <div className={styles.buttonClose}>
            <ButtonClose onClick={this.hideMe} />
          </div>
        </nav>
        <div
          className={styles.bg}
          onClick={this.hideMe}
          style={{ display: this.props.isSidebarOpen ? 'block' : 'none' }}
        ></div>
      </React.Fragment>
    );
  }
}

const Wrapped = withSocialMediaLinks(withSidebarNavigation(OverlaySidebar));

Wrapped.region = REGION_OVERLAYS;
Wrapped.fragment = OVERLAY_FRAGMENT;

export default Wrapped;
